import { Breadcrumb, ConfigProvider, DatePicker, PaginationProps, Space, TreeSelect } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../../../Layout';
import { CampaignStats, getChartCustomerReportRank, getChartMemberFluctuation, getChartReportRankDemographics, getReportComplaintByBusinessType, getReportComplaintByBusinessTypeAndBrand, getReportComplaintStatisticsComplaint, getReportRankCustomerDistributionByAge, getReportRankCustomerDistributionByRegion, getReportTopComplaintChannels, IChartCustomerReportRank, IChartMemberFluctuation, IChartReportRankDemographics, IReportCampaignVehicleDistributionByAgeV2, IReportComplaintStatisticsComplaint, Row } from '../../../api/reportCustomer/reportCustomerApi';
import { getListRank, getSLUnitByPermission, IRank } from '../../../api/selectOptions/selectOptionsApi';
import { convertNationwideValueToTree_V2 } from '../../../api/unit/unitApi';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useToast from '../../../hook/useToast';
import { formatNumber } from '../../../services/mixin';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { formatDateV2, getUserPermissions } from '../../../until';
import StatisticCard from './StatisticCard';
import ComplaintsByBusinessBrandTable from './components/ComplaintsByBusinessBrandTable';
import { HorizontalBarChart } from './components/HorizontalBarChart';
import MembershipTierMonthlyTable from './components/MembershipTierMonthlyTable';
import ReportFluctuationYearly from './components/ReportFluctuationYearly';
import ReportTableTotalMembers from './components/ReportTableTotalMembers';
import './styles.scss';

const { RangePicker } = DatePicker;

export enum TYPEFILTERTOP {
    ADDRESS = 0,
    CHANNEL = 1,
}


interface CustomerGrowthData {
    year: number;
    totalCustomers: number;
    growthCount: number;
    growthRate: number;
}

interface CustomerGrowthChartData {
    years: string[];
    totalCustomers: number[];
    growthRates: number[];
}

export interface ChartData {
    name: string;
    value: number;
    color: string;
    id?: number;
}

const DEFAULT_COLORS = [
    "#3D99F5", // Member
    "#39C2C9", // Silver
    "#45C35B", // Gold
    "#FFC928", // Plantium
    "#F15672", // Diamond
    "#8B56DD", // Diamond 1
    "#4E56D9", // Diamond 2
    "#344A91", // Không xác định
];

const randomColor = (): string => {
    const letters = "0123456789ABCDEF";

    let color = "#";

    for (let i = 0; i < 6; i++) {
        color += letters[
            Math.floor(Math.random() * 16)
        ];
    }

    return color;
};

const convertRankDataToChartData = (
    data: IChartCustomerReportRank[] | undefined | null
): ChartData[] => {

    if (!data || data.length === 0) {
        return [];
    }

    return data.map((item, index) => ({
        name: item.rankName,
        value: item.count,
        color:
            index < DEFAULT_COLORS.length
                ? DEFAULT_COLORS[index]
                : randomColor(),
        id: item.rankId,
    }));
};




const convertCustomerGrowthData = (
    data: IChartMemberFluctuation[] | undefined | null
): CustomerGrowthChartData => {

    if (!data?.length) {
        return {
            years: [],
            totalCustomers: [],
            growthRates: [],
        };
    }

    return {
        years: data.map(item => String(item.year)),

        totalCustomers: data.map(
            item => item.totalCustomers ?? 0
        ),

        growthRates: data.map(
            item => item.growthRate ?? 0
        ),
    };
};


const buildTopWithOther = (
    data: { name: string; value: number }[],
    top: number
) => {
    const sorted = [...data].sort((a, b) => b.value - a.value);
    const main = sorted.slice(0, top - 1);
    const otherSum = sorted.slice(top - 1).reduce((s, i) => s + i.value, 0);

    return otherSum > 0 ? [...main, { name: "Khác", value: otherSum }] : main;
};

const convertAgeRangeToValue = (value?: string | null): number | undefined => {
    if (!value) return undefined;

    const normalized = value
        .trim()
        .replace(/\s+/g, "");

    const ageRangeMap: Record<string, number> = {
        "Khôngxácđịnh": 0,
        "<20": 1,
        "20-25": 2,
        "26-29": 3,
        "30-39": 4,
        "40-49": 5,
        "50-59": 6,
        "60+": 7
    };

    return ageRangeMap[normalized];
};

interface CustomerFilterSearch {
    campaign?: string
}

export interface TypeTotalReport {
    zns?: CampaignStats
    sms?: CampaignStats
    email?: CampaignStats
}

export interface IDataDefaulFilter {
    unitIds?: number[],
    date?: string,

    rankIds?: number[],
    fromMonth?: string,
    toMonth?: string,
}

const ComplaintsGrievances: React.FC = () => {
    const pushToast = useToast();
    const pushLoading = useLoading()
    const navigate = useNavigate()

    const location = useLocation();
    const { unitTemp } = useSelector(selectorInfoUser)

    const permissionSlice = useSelector(selectorPermission)
    const { add, edit, delete: isdelete, upload, download } = getUserPermissions(permissionSlice, location.pathname)
    // const [dataReportRankDemographics, setDataReportRankDemographics] = useState<IChartReportRankDemographics>()
    // const [dataReportCampaignVehicleDistributionByAge, setDataReportCampaignVehicleDistributionByAge] = useState<IReportCampaignVehicleDistributionByAgeV2>()
    const [dataReportComplaintByBusinessTypeAndBrand, setDataReportComplaintByBusinessTypeAndBrand] = useState<any>()
    const [dataReportTopComplaintChannels, setDataReportTopComplaintChannels] = useState<any[]>()

    // data báo cáo hạng thành viên


    const [dataComplaintStatisticsComplaint, setDataComplaintStatisticsComplaint] = useState<IReportComplaintStatisticsComplaint>()


    // const [dataChartCustomerReportRank, setDataChartCustomerReportRank] = useState<ChartData[]>()
    // const [dataChartMemberFluctuation, setDataChartMemberFluctuation] = useState<CustomerGrowthChartData>()
    const [dataRank, setDataRank] = useState<IRank[]>([])
    const [sLUnitByPermission, setSLUnitByPermission] = useState<any>()






    const [dataFilter, setDataFilter] = useState<IDataDefaulFilter>()
    const [total, setTotal] = useState<number>()

    // ─── Complaints by business & brand ──────────────────────────────────
    const [complaintBrandColumns, setComplaintBrandColumns] = useState<string[]>([]);
    const [complaintBrandIdMap, setComplaintBrandIdMap] = useState<Record<string, number>>({});
    const [complaintByBusinessTypeAndBrand, setComplaintByBusinessTypeAndBrand] = useState<Row[]>();

    const [valueTop, setValueTop] = useState<Record<TYPEFILTERTOP, number>>({
        [TYPEFILTERTOP.ADDRESS]: 10,
        [TYPEFILTERTOP.CHANNEL]: 10,
    });


    // const dataCampaignVehicleDistributionByAge = useMemo(() => {
    //     if (!dataReportCampaignVehicleDistributionByAge) return [];
    //     const sum = (key: keyof IReportCampaignVehicleDistributionByAgeV2) => dataReportCampaignVehicleDistributionByAge[key] || 0;
    //     return [
    //         { name: 'Không xác định', value: dataReportCampaignVehicleDistributionByAge.undetermined },
    //         { name: '< 20', value: dataReportCampaignVehicleDistributionByAge.ageUnder20 },
    //         { name: '20 - 25', value: dataReportCampaignVehicleDistributionByAge.ageBetween2025 },
    //         { name: '26 - 29', value: dataReportCampaignVehicleDistributionByAge.ageBetween2629 },
    //         { name: '30 - 39', value: dataReportCampaignVehicleDistributionByAge.ageBetween3039 },
    //         { name: '40 - 49', value: dataReportCampaignVehicleDistributionByAge.ageBetween4049 },
    //         { name: '50 - 59', value: dataReportCampaignVehicleDistributionByAge.ageBetween5059 },
    //         { name: '60+', value: dataReportCampaignVehicleDistributionByAge.ageOver60 },
    //     ];
    // }, [dataReportCampaignVehicleDistributionByAge]);



    const gSLRank = async () => {
        const result = await getListRank();
        if (result?.status) {
            setDataRank(result.data)
        } else {
            pushToast(result?.message, "error", 2000)

        }
    }

    const gSLUnitByPermission = async () => {
        const result = await getSLUnitByPermission(unitTemp);
        if (result?.status) {
            setSLUnitByPermission(convertNationwideValueToTree_V2(result.data))
        } else {
        }
    }


    const gReportComplaintByBusinessTypeAndBrand = useDebounce(async () => {
        pushLoading(true)
        const result = await getReportComplaintByBusinessTypeAndBrand(
            unitTemp,
            dataFilter?.unitIds,
            dataFilter?.date,
        )
        if (result.status) {
            const brands = (result.data?.brands ?? []).map((b: any) => typeof b === 'string' ? b : b.title ?? String(b.id));
            const brandIdMap: Record<string, number> = {};
            (result.data?.brands ?? []).forEach((b: any) => {
                if (typeof b === 'object' && b.id != null) {
                    const key = b.title ?? String(b.id);
                    brandIdMap[key] = b.id;
                }
            });
            setComplaintBrandColumns(brands)
            setComplaintBrandIdMap(brandIdMap)
            setComplaintByBusinessTypeAndBrand(result.data?.rows ?? [])
        }
        pushLoading(false)
    }, 500)


    const gReportComplaintStatisticsComplaint = useDebounce(async () => {
        pushLoading(true)
        const result = await getReportComplaintStatisticsComplaint(
            unitTemp,
            dataFilter?.unitIds,
            dataFilter?.date,
        )
        if (result.status) {
            setDataComplaintStatisticsComplaint(result.data)
        }
        pushLoading(false)
    }, 500)




    // const gChartCustomerReportRank = useDebounce(async () => {
    //     pushLoading(true)
    //     const result = await getChartCustomerReportRank(
    //         unitTemp,
    //         dataFilter?.unitIds,
    //         dataFilter?.rankIds,
    //         dataFilter?.fromMonth,
    //         dataFilter?.toMonth,
    //     )
    //     if (result.status) {
    //         setDataChartCustomerReportRank(convertRankDataToChartData(result.data))
    //     }
    //     pushLoading(false)
    // }, 500)


    // const gChartMemberFluctuation = useDebounce(async (limit: number = 5) => {
    //     pushLoading(true)
    //     const result = await getChartMemberFluctuation(
    //         limit,
    //         unitTemp,
    //         dataFilter?.unitIds,
    //         dataFilter?.rankIds,
    //         dataFilter?.fromMonth,
    //         dataFilter?.toMonth,
    //     )
    //     if (result.status) {
    //         setDataChartMemberFluctuation(convertCustomerGrowthData(result.data))
    //     }
    //     pushLoading(false)
    // }, 500)

    // const gChartReportRankDemographics = useDebounce(async () => {
    //     pushLoading(true)
    //     const result = await getChartReportRankDemographics(
    //         unitTemp,
    //         dataFilter?.unitIds,
    //         dataFilter?.rankIds,
    //         dataFilter?.fromMonth,
    //         dataFilter?.toMonth,

    //     )
    //     if (result.status) {
    //         setDataReportRankDemographics(result.data)
    //         // setTotal(result.total)
    //     }
    //     pushLoading(false)
    // }, 500)

    // const gListReportCampaign = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    //     pushLoading(true)
    //     const result = await getListReportCampaign(
    //         pageSize, pageCurent, unitTemp,
    //         dataFilter?.status, dataFilter?.dateCreate,
    //         dataFilter?.dateSend, dataFilter?.campaign, dataFilter?.brandName

    //     )
    //     if (result.status) {
    //         setDataReportCampaign(result.data)
    //         setPagination({ current: pageCurent, total: result.total, pageSize })
    //         setTotalReport({
    //             zns: result?.zns,
    //             sms: result?.sms,
    //             email: result?.email
    //         })
    //         setTotal(result.total)
    //     }
    //     pushLoading(false)
    // }, 500)



    // const gReportRankCustomerDistributionByAge = useDebounce(async () => {
    //     pushLoading(true)
    //     const result = await getReportRankCustomerDistributionByAge(
    //         unitTemp,
    //         dataFilter?.unitIds,
    //         dataFilter?.rankIds,
    //         dataFilter?.fromMonth,
    //         dataFilter?.toMonth,

    //     )
    //     if (result.status) {
    //         setDataReportCampaignVehicleDistributionByAge(result.data)
    //         // setTotal(result.total)
    //     }
    //     pushLoading(false)
    // }, 500)

    const gReportRankCustomerDistributionByRegion = useDebounce(async () => {
        pushLoading(true)
        const result = await getReportComplaintByBusinessType(
            unitTemp,
            dataFilter?.unitIds,
            dataFilter?.date

        )
        if (result.status) {
            const raw = result.data.values ?? {};
            const chartData = Object.entries(raw).map(([name, value]) => ({
                name,
                value,
            }));
            setDataReportComplaintByBusinessTypeAndBrand(chartData)
        }
        pushLoading(false)
    }, 500)



    const gReportTopComplaintChannels = useDebounce(async () => {
        pushLoading(true)
        const result = await getReportTopComplaintChannels(
            unitTemp,
            dataFilter?.unitIds,
            dataFilter?.date,
            valueTop[TYPEFILTERTOP.CHANNEL]
        )
        if (result.status) {
            const raw = result.data.map(item => ({
                name: item.name,
                // id: item.jobId,
                value: item.total,
            }));
            setDataReportTopComplaintChannels(raw)
            // setTotal(result.total)
        }
        pushLoading(false)
    }, 500)



    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        // gListReportCampaign(pageNumber, pageSize)
    }



    useEffect(() => {
        gReportComplaintStatisticsComplaint()
        // gChartCustomerReportRank()
        // gChartMemberFluctuation()
        // gChartReportRankDemographics()
        // gReportRankCustomerDistributionByAge()
        gReportRankCustomerDistributionByRegion()

        // new

    }, [dataFilter, unitTemp])


    useEffect(() => {
        gReportTopComplaintChannels()
    }, [dataFilter, unitTemp, valueTop[TYPEFILTERTOP.CHANNEL]])


    useEffect(() => {
        // gSLBrandName()
        gSLUnitByPermission()

    }, [unitTemp])

    useEffect(() => {
        gReportComplaintByBusinessTypeAndBrand()
        // gSLBrandName()
        gSLRank()

    }, [])




    return (
        <div className='card-issuance-list'>
            <Layout className='custom-sidebar-chart'>

                <Breadcrumb
                    items={[
                        {
                            title: 'THACO AUTO CRM',
                        },
                        {
                            title: <a href="/">Báo cáo phân tích</a>,
                        },
                        {
                            title: 'Tổng quan phàn nàn/ khiếu nại',
                        },
                    ]}
                />

                <div className='title-page'>
                    Tổng quan phàn nàn/ khiếu nại
                </div>


                <div className="campaign-filter">

                    <Space
                        wrap
                        size={16}
                        className="campaign-filter__toolbar"
                        align='start'
                    >
                        <ConfigProvider locale={viVN}>
                            <DatePicker
                                className="custom-input-date custom-page-css flex flex-1 "
                                placeholder="Ngày ghi nhận"
                                format="DD/MM/YYYY"
                                allowClear
                                onChange={(e) => setDataFilter({ ...dataFilter, date: e ? formatDateV2(e.toDate()) : undefined })}
                            />
                        </ConfigProvider>
                        <TreeSelect
                            className='custom-page-css border rounded overflow-hidden w-300px custom-scroll-multi-select'
                            multiple
                            showSearch
                            placeholder="Đơn vị"
                            allowClear
                            value={dataFilter?.unitIds}
                            treeDefaultExpandAll={false}
                            treeData={sLUnitByPermission}
                            filterTreeNode={(input: string, option: any) =>
                                typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={(e) => setDataFilter({ ...dataFilter, unitIds: e !== undefined ? e : undefined })}
                        />


                        {/* <ConfigProvider locale={viVN}>
                            <DatePicker
                                className="custom-input-date"
                                placeholder="Ngày gửi chiến dịch"
                                format="DD/MM/YYYY"
                                allowClear
                                onChange={(e) => setDataFilter({ ...dataFilter, dateSend: e ? formatDateV2(e.toDate()) : undefined })}
                            />
                        </ConfigProvider> */}

                        {/* <Button
                            icon={<DownloadOutlined />}
                            loading={isExporting}
                            onClick={handleExportExcel}
                        >
                            Xuất báo cáo
                        </Button> */}

                    </Space>

                </div>


                <div className='custom-page-css w-full flex  gap-2 pt-4'>

                    <div className="custom-page-css flex flex-1">
                        <StatisticCard
                            colors={['#1890FF', '#005DB2']}
                            title='Tổng khiếu nại'
                            value={formatNumber(dataComplaintStatisticsComplaint?.total ?? 0)}
                            onClick={() => navigate('/analysis-report/complaint-detail-list', {
                                state: { group: 1, dateCreate: dataFilter?.date, listUnit: dataFilter?.unitIds, unitScopeId: unitTemp, title: 'Tổng khiếu nại', apiType: 'statisticsComplaint' }
                            })}
                        />
                    </div>

                    <div className="custom-page-css flex flex-1">
                        <StatisticCard
                            colors={['#F59C23', '#F55E09']}
                            title='Đang xử lý'
                            value={formatNumber(dataComplaintStatisticsComplaint?.totalProcessing ?? 0)}
                            grow={((dataComplaintStatisticsComplaint?.totalProcessing ?? 0) / (dataComplaintStatisticsComplaint?.total ?? 0) * 100).toFixed(2)}
                            onClick={() => navigate('/analysis-report/complaint-detail-list', {
                                state: { group: 2, dateCreate: dataFilter?.date, listUnit: dataFilter?.unitIds, unitScopeId: unitTemp, title: 'Đang xử lý', apiType: 'statisticsComplaint' }
                            })}
                        />
                    </div>

                    <div className="custom-page-css flex flex-1">
                        <StatisticCard
                            colors={['#7B61FF', '#4F00B2']}
                            title='Đã đóng'
                            value={formatNumber(dataComplaintStatisticsComplaint?.totalClosed ?? 0)}
                            onClick={() => navigate('/analysis-report/complaint-detail-list', {
                                state: { group: 3, dateCreate: dataFilter?.date, listUnit: dataFilter?.unitIds, unitScopeId: unitTemp, title: 'Đã đóng', apiType: 'statisticsComplaint' }
                            })}
                        />
                    </div>
                    <div className="custom-page-css flex flex-1">
                        <StatisticCard
                            colors={['#99a0ac', '#3d4757']}
                            title='Không xác định'
                            value={formatNumber(dataComplaintStatisticsComplaint?.totalUnknown ?? 0)}
                            onClick={() => navigate('/analysis-report/complaint-detail-list', {
                                state: { group: 4, dateCreate: dataFilter?.date, listUnit: dataFilter?.unitIds, unitScopeId: unitTemp, title: 'Không xác định', apiType: 'statisticsComplaint' }
                            })}
                        />
                    </div>
                </div>

                <div className="custom-page-css flex items-stretch gap-4 pt-4">
                    <div
                        className="custom-page-css flex flex-1">
                        <HorizontalBarChart
                            type={TYPEFILTERTOP.ADDRESS}
                            title="Phân loại khiếu nại, phàn nàn theo loại hình kinh doanh"
                            data={dataReportComplaintByBusinessTypeAndBrand}
                            valueTop={valueTop}
                            setValueTop={setValueTop}
                            showValueTop={false}
                            color="#8979FF"
                            dataFilter={dataFilter}
                        />
                    </div>

                    <div
                        className="custom-page-css flex flex-1">
                        <HorizontalBarChart
                            type={TYPEFILTERTOP.CHANNEL}
                            title="Top khiếu nại, phàn nàn theo kênh tiếp nhận "
                            data={dataReportTopComplaintChannels}
                            valueTop={valueTop}
                            showValueTop={true}
                            setValueTop={setValueTop}
                            color="#1890FF"
                            dataFilter={dataFilter}
                            unitScopeId={unitTemp}
                        />
                    </div>
                </div>

                <div className='custom-page-css flex flex-col gap-1 pt-4'>
                    <span className='custom-page-css text-base font-medium'>Bảng thống kê khiếu nại, phàn nàn theo loại hình kinh doanh &amp; thương hiệu</span>
                </div>
                <ComplaintsByBusinessBrandTable
                    data={complaintByBusinessTypeAndBrand}
                    brandColumns={complaintBrandColumns}
                    brandIdMap={complaintBrandIdMap}
                    dataFilter={dataFilter}
                />

                {/* ở đây */}
                {/* <ReportFluctuationYearly
                    dataFilter={dataFilter}
                />




                <MembershipTierMonthlyTable dataFilter={dataFilter} dataRank={dataRank} /> */}

                <span className='text-base font-medium pt-4'>Bảng thống kê khiếu nại, phàn nàn theo loại hình kinh doanh & công ty tỉnh thành</span>
                <ReportTableTotalMembers
                    dataFilter={dataFilter}
                    dataRank={dataRank}
                    setTotal={setTotal}
                />

                <span className='text-base font-medium pt-4'>Bảng thống kê khiếu nại, phàn nàn kinh doanh theo công ty tỉnh thành</span>
                <ReportTableTotalMembers
                    dataFilter={dataFilter}
                    dataRank={dataRank}
                    setTotal={setTotal}
                    apiType="businessDdmsByUnit" />


                <span className='text-base font-medium pt-4'>Bảng thống kê khiếu nại, phàn nàn dịch vụ theo công ty tỉnh thành</span>
                <ReportTableTotalMembers
                    dataFilter={dataFilter}
                    dataRank={dataRank}
                    setTotal={setTotal}
                    apiType="serviceDdmsByUnit" />



                <span className='text-base font-medium pt-4'>Bảng thống kê khiếu nại, phàn nàn khác theo công ty tỉnh thành</span>
                <ReportTableTotalMembers
                    dataFilter={dataFilter}
                    dataRank={dataRank}
                    setTotal={setTotal}
                    apiType="otherDdmsByUnit"
                />


            </Layout>
        </div>
    );
}

export default ComplaintsGrievances;
